/* eslint-disable react/no-multi-comp, no-underscore-dangle, no-unneeded-ternary,
react/sort-comp, class-methods-use-this, import/namespace, jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events,
jsx-a11y/no-static-element-interactions, @typescript-eslint/no-unused-vars, jsx-a11y/no-noninteractive-element-interactions */
import React from "react"
import { connect } from "react-redux"
import Immutable from "immutable"
import PropTypes from "prop-types"
import classNames from "classnames"
import ReactBootstrapSlider from "react-bootstrap-slider"
import swal from "sweetalert"

import Tooltip from "components/Tooltip"
import NetworkGraph from "graphs/components/NetworkGraph"
import { LoadingSpinner } from "components/LoadingSpinner"
import { Col, FormLabel } from "react-bootstrap"
import { cleanFilters, ordinalSuffix } from "imports/desktopHelperFunctions"
import { sendUserActionPost } from "shared/user-actions/user-actions-action-creators"

import { filterHasValue } from "shared/search/helperFunctions"
import { selectNetworkGraphProps } from "search-new/selectors"
import { updateFilter, updateMultipleFilters } from "shared/search/action-creators"

import * as constants from "imports/desktopConstants"

import {
    NoteInvolvingMemberFilter,
    NoteInvolvingSupporterFilter,
    NoteInvolvingOrganizationFilter,
    NoteInvolvingUserFilter,
} from "shared/search/containers/Filter/NoteFilters"

/**
 * This component is ill-named. It was orginially written for the network graph in search, but now it is used
 * for profile and issue relationship graphs too.
 */

const MIN_DEGREES_SEPARATION = 1
const MAX_DEGREES_SEPARATION = 6 // <-- this was just an estimated guess, take it with a grain of salt
const MAX_LINKS = 2000
const GRAPH_WRAPPER_ID = "network-graph"

const NodeType = {
    Person: {
        resource: DjangIO.app.models.QuorumDataType.person,
        filterId: NoteInvolvingMemberFilter.defaultProps.uniqueFilterId,
        filterKey: NoteInvolvingMemberFilter.defaultProps.filterKey, // "involving_member",
        color: constants.QUORUM_GREY_5,
    },
    Supporter: {
        resource: DjangIO.app.models.QuorumDataType.supporter,
        filterId: NoteInvolvingSupporterFilter.defaultProps.uniqueFilterId,
        filterKey: NoteInvolvingSupporterFilter.defaultProps.filterKey, // "involving_supporter",
        color: constants.HYPER_LINK_PURPLE,
    },
    Organization: {
        resource: DjangIO.app.models.QuorumDataType.public_organization,
        filterId: NoteInvolvingOrganizationFilter.defaultProps.uniqueFilterId,
        filterKey: NoteInvolvingOrganizationFilter.defaultProps.uniqueFilterId, // "involving_public_organization",
        color: constants.GRAPH_BLUES_COLOR_RANGE[3],
    },
    User: {
        resource: DjangIO.app.models.QuorumDataType.user,
        filterId: NoteInvolvingUserFilter.defaultProps.uniqueFilterId,
        filterKey: NoteInvolvingUserFilter.defaultProps.uniqueFilterId, // "involving_user",
        color: constants.QUORUM_BLUE,
    },
    // for the official relationship graph
    Republican: {
        resource: DjangIO.app.models.QuorumDataType.person,
        color: constants.PARTY_COLORS.REPUBLICAN,
    },
    Democrat: {
        resource: DjangIO.app.models.QuorumDataType.person,
        color: constants.PARTY_COLORS.DEMOCRAT,
    },
    Other: {
        resource: DjangIO.app.models.QuorumDataType.person,
        color: constants.PARTY_COLORS.OTHER,
    },
    Independent: {
        resource: DjangIO.app.models.QuorumDataType.person,
        color: constants.PARTY_COLORS.INDEPENDENT,
    },
    // in brackets because of hyphen
    "Non-Designated": {
        resource: DjangIO.app.models.QuorumDataType.person,
        color: constants.QUORUM_GREY_1,
    },
}

// NodeTypes to show in the 'Filter By Type' filter
const NODE_FILTER_TYPES = [NodeType.Person, NodeType.Supporter, NodeType.Organization, NodeType.User]

class GraphPanelGroup extends React.Component {
    static propTypes = {
        panelId: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        tooltipText: PropTypes.string.isRequired,
        content: PropTypes.object.isRequired,
    }

    state = { isActive: false }

    toggleActive = () => this.setState({ isActive: !this.state.isActive })

    render() {
        return (
            <div className="filter-group panel panel-default" id={this.props.panelId} key={this.props.panelId}>
                <div
                    onClick={this.toggleActive}
                    className={classNames({
                        "panel-heading": true,
                        active: this.state.isActive,
                    })}
                >
                    <h4>
                        {this.props.title}
                        <i
                            className={classNames("fa fa-fw", {
                                "fa-chevron-down": this.state.isActive,
                                "fa-chevron-left": !this.state.isActive,
                            })}
                        />
                        <Tooltip label={this.props.tooltipText} placement="top">
                            <i className="fa fa-fw fa-info-circle" id="info-click" />
                        </Tooltip>
                    </h4>
                </div>
                {this.state.isActive && this.props.content}
            </div>
        )
    }
}

class AdvancedSearchNetworkGraph extends React.Component {
    constructor() {
        super()
        // click handlers for controls
        this.increaseDegreesSeparation = this.increaseDegreesSeparation.bind(this)
        this.decreaseDegreesSeparation = this.decreaseDegreesSeparation.bind(this)
        this.setStrengthConstraint = this.setStrengthConstraint.bind(this)
        this.toggleLabels = this.toggleLabels.bind(this)
        this.toggleTooltips = this.toggleTooltips.bind(this)
        this.toggleDegreesBtn = this.toggleDegreesBtn.bind(this)
        this.toggleNodeTypeBtn = this.toggleNodeTypeBtn.bind(this)
        this.toggleSliderPanelBtn = this.toggleSliderPanelBtn.bind(this)
        this.clearFilterSelections = this.clearFilterSelections.bind(this)
        // click/mouseover handlers for graph
        this.selectNodeInGraph = this.selectNodeInGraph.bind(this)
        this.selectLinkInGraph = this.selectLinkInGraph.bind(this)
        this.getNodeTooltipContent = this.getNodeTooltipContent.bind(this)
        this.publishFilters = this.publishFilters.bind(this)
        this.toggleOnlyShowSelected = this.toggleOnlyShowSelected.bind(this)
        this.clearSelectedNodes = this.clearSelectedNodes.bind(this)
        this.downloadCSV = this.downloadCSV.bind(this)

        this.state = {
            degreesSeparation: 1,
            showLabels: false,
            loading: true,
            nodeMap: {},
            data: { links: [], nodes: [] },
            strengthConstraint: 1,
            selectedNodes: [],
            selectedLinks: [],
            degreesBtnActive: false,
            nodeTypesBtnActive: false,
            linkSliderBtnActive: false,
            count: undefined,
            activeNodeTypes: NODE_FILTER_TYPES.map(({ resource }) => resource.value),
            allowTooltips: true,
            onlyShowSelected: false,
        }
    }

    componentDidMount() {
        // if it is in the note search, fetch the data
        if (!this.props.isStats) {
            this.fetchData()
            // if it is in the stats page, use the data that is passed down to it
        } else if (this.props.data) {
            this.parseAndSetData(this.props.data)
        }
    }

    componentDidUpdate(oldProps) {
        if (!this.props.currentFilters.equals(oldProps.currentFilters)) {
            this.fetchData()
        }
    }

    componentWillUnmount() {
        // Abort any pending requests because the component is about to tear
        // itself down.
        if (this.networkAxiosReq) {
            this.networkAxiosReq.abort()
        }
    }

    fetchData() {
        // Abort any pending requests because we're about to make a new one.
        if (this.networkAxiosReq) {
            this.networkAxiosReq.abort()
        }

        // if no node types selected, then data will be empty
        if (!this.state.activeNodeTypes.length) {
            const emptyData = { nodes: [], links: [] }
            return this.setState({ data: emptyData })
        }

        this.setState({ loading: true })

        this.networkAxiosReq = this.props.resource.objects
            .filter(this.props.currentFilters.toJS())
            .action("network")
            .filter({
                degrees: this.state.degreesSeparation,
                desired_types: this.state.activeNodeTypes,
            })
            .all()
            .GET()

        return this.networkAxiosReq.then(
            (data) => {
                this.parseAndSetData(data)
            },
            (err) => {
                if (!err.__CANCEL__) {
                    return BACKENDERROR(err)
                }
                return null
            },
        )
    }

    publishFilters() {
        const aggregate = {}
        // aggregate all selctions made through clicking nodes and links
        // into a list of ids
        const allSelections = Object.assign([], this.state.selectedNodes)
        this.state.selectedLinks.map((linkId) => {
            const [sourceId, targetId] = linkId.split("-to-")
            ;[sourceId, targetId].forEach((uniqueId) => {
                if (!allSelections.includes(uniqueId)) {
                    allSelections.push(uniqueId)
                }
            })
        })
        // for each selection, get the database and filter key to use, then add to filter
        allSelections.forEach((uniqueNodeId) => {
            const node = this.state.nodeMap[uniqueNodeId]
            // get database id
            const dbId = node.database_id
            // get filter key
            const filterId = NodeType[node.node_type].filterId
            // add to filter
            if (!aggregate[filterId]) {
                aggregate[filterId] = []
            }
            aggregate[filterId].push(dbId)
        })

        const newFilters = Object.keys(aggregate).map((filterId) => {
            const serializedValue = aggregate[filterId].join(",")
            return {
                uniqueFilterId: filterId,
                value: serializedValue,
                hasValue: filterHasValue(serializedValue),
            }
        })

        this.props.updateMultipleFilters(this.props.uniqueFlvId, newFilters)
    }

    parseData(data) {
        const NUM_NODE_LABELS_TO_DISPLAY = 10
        const importantNodes = []
        // format nodes for graph
        const formattedData = this.filterDataByStrength(data.edges)

        formattedData.links = Object.assign([], data.edges)
        // only links have frequency, so add to nodes the sum of all the frequency's of linke connected to the node
        formattedData.links.forEach((link) => {
            ;[link.source, link.target].forEach((uniqueNodeId) => {
                const currentFreq = data.nodes[uniqueNodeId].frequency
                data.nodes[uniqueNodeId].frequency =
                    isNaN(currentFreq) || uniqueNodeId === this.props.graphProps.centerNodeId
                        ? link.frequency
                        : currentFreq + link.frequency
            })
        })

        // to make it easier to filter by number of links,
        // put links in descending order of their frequency
        formattedData.links = formattedData.links.sort((link1, link2) => link2.frequency - link1.frequency)

        // with links now sorted, grab the top important nodes that graph willl how labels for
        formattedData.links.slice(0, NUM_NODE_LABELS_TO_DISPLAY).forEach((link) => {
            ;[link.source, link.target].forEach((uniqueNodeId) => {
                // if this node isn't already in the list of important nodes
                // and the list isn't already long enough, then add the node
                if (!importantNodes.includes(uniqueNodeId) && importantNodes.length < NUM_NODE_LABELS_TO_DISPLAY) {
                    importantNodes.push(uniqueNodeId)
                }
            })
        })

        return [formattedData, data.nodes, importantNodes]
    }

    parseAndSetData(data) {
        const [formattedData, nodeMap, importantNodes] = this.parseData(data)
        // // if graph does not have selectable nodes, then add the most importantNodes as selected nodes so that their labels appear
        // const selectedNodes = this.props.cannotSelectNodes
        //     ? this.state.selectedNodes.concat(importantNodes.filter(({ id }) => !this.state.selectedNodes.includes(id)))
        //     : this.state.selectedNodes
        this.setState({
            nodeMap,
            data: formattedData,
            loading: false,
        })
    }

    /*
        Expects links argument to be an array and that raw data for nodes
        to be in this.state.nodeMap
     */
    filterDataByStrength(unfilteredLinks) {
        const maxNumLinksToDisplay = unfilteredLinks.length > MAX_LINKS ? MAX_LINKS : unfilteredLinks.length

        // (which are already sorted in descending order of frequency)
        const links = unfilteredLinks
            .filter((link) => link.frequency >= this.state.strengthConstraint)
            .slice(0, maxNumLinksToDisplay)

        // now that we have the links, filter out nodes that aren't linked
        // by only grabbing the nodes that are in the links
        const nodes = links
            .reduce((acc, link) => {
                if (!acc.includes(link.source)) {
                    acc.push(link.source)
                }
                if (!acc.includes(link.target)) {
                    acc.push(link.target)
                }
                return acc
            }, [])
            .map((id) => ({ id }))

        return { links, nodes }
    }

    filterDataBySelection({ links, nodes }) {
        const { selectedNodes } = this.state

        const filteredLinks = links.filter(
            (link) => selectedNodes.includes(link.source) && selectedNodes.includes(link.target),
        )

        const filteredNodes = nodes.filter((node) => selectedNodes.includes(node.id))

        return { links: filteredLinks, nodes: filteredNodes }
    }

    /*
        Clicking a node adds the node's unique id to the filter
        (unique id'S converted to an actual filter )
     */
    selectNodeInGraph(node) {
        if (this.props.cannotSelectNodes) {
            return
        }

        let filter = Object.assign([], this.state.selectedNodes)
        // if we don't have this filter yet, start an array
        if (!filter) {
            filter = []
        }

        // if node already selected, then remove from selected
        if (filter.includes(node.id)) {
            const indexToRemove = filter.indexOf(node.id)
            filter = filter.slice(0, indexToRemove).concat(filter.slice(indexToRemove + 1, filter.length))
        }
        // if node not selected, select it
        else {
            filter = filter.concat([node.id])
        }

        this.setState({ selectedNodes: filter })
    }

    /*
        When link is clicked, we set a filter on participants for the source
        and target associated.
        Create new selectedLinks to give to graph.
        selectedLinks is an array for links in form [`${sourceId1}-to-${targetId1}`, ...]
     */
    selectLinkInGraph(link) {
        const selectedLinks = this.state.selectedLinks
        // get unique id's from link
        const sourceUniqueId = link.source.id
        const targetUniqueId = link.target.id
        const newSelectionId = `${sourceUniqueId}-to-${targetUniqueId}`

        // if this link is already in this.state.selectedLinks,
        // then remove it (de-select)
        if (selectedLinks.includes(newSelectionId)) {
            const index = selectedLinks.indexOf(newSelectionId)
            selectedLinks.splice(index, 1)
        }
        // add this new selection
        else {
            selectedLinks.push(newSelectionId)
        }

        this.setState({ selectedLinks })
    }

    clearFilterSelections() {
        this.setState({ selectedNodes: [], selectedLinks: [] })

        const aggregate = Object.values(NodeType).map((datum) => ({
            uniqueFilterId: datum.filterId,
            value: undefined,
            hasValue: false,
        }))

        this.props.updateMultipleFilters(this.props.uniqueFlvId, aggregate)
    }

    toggleOnlyShowSelected() {
        this.setState({ onlyShowSelected: !this.state.onlyShowSelected })
    }

    clearSelectedNodes() {
        this.setState({
            onlyShowSelected: false,
            selectedNodes: [],
        })
    }

    toggleActiveNodeTypes(type) {
        const nodeTypes = this.state.activeNodeTypes
        // if type is active, then remove from activeNodeTypes list, o.w. add it
        if (nodeTypes.includes(type)) {
            nodeTypes.splice(nodeTypes.indexOf(type), 1)
        } else {
            nodeTypes.push(type)
        }
        this.setState({ activeNodeTypes: nodeTypes }, this.fetchData)
    }

    setDegreesSeparation(num) {
        this.setState({ degreesSeparation: num }, this.fetchData)
    }

    increaseDegreesSeparation() {
        if (this.state.degreesSeparation !== MAX_DEGREES_SEPARATION) {
            this.setDegreesSeparation(this.state.degreesSeparation + 1)
        }
    }

    decreaseDegreesSeparation() {
        if (this.state.degreesSeparation !== MIN_DEGREES_SEPARATION) {
            this.setDegreesSeparation(this.state.degreesSeparation - 1)
        }
    }

    setStrengthConstraint(e) {
        this.setState({ strengthConstraint: e.target.value })
    }

    getNodeTooltipContent(uniqueNodeId) {
        if (this.props.getNodeTooltipContent) {
            const node = this.state.nodeMap[uniqueNodeId]
            return this.props.getNodeTooltipContent(uniqueNodeId, node.frequency)
        }
        // NoteFLV case
        const node = this.state.nodeMap[uniqueNodeId]
        return node.min_degree
            ? `
                <p class="main-text"><strong>${node.name}</strong></p><hr>
                <strong>Degree of Separation</strong>
                <span style="float: right; margin-left: 25px">
                    ${node.min_degree}
                </span>
                </br>
            `
            : `
                <p class="main-text"><strong>${node.name}</strong></p>
            `
    }

    /*
        Closes all other toggles than the exception
     */
    closeAllOtherToggles(exception) {
        const newState = Object.assign(
            {},
            {
                degreesBtnActive: false,
                nodeTypesBtnActive: false,
                linkSliderBtnActive: false,
            },
            { [exception]: this.state[exception] },
        )
        this.setState(newState)
    }

    togglePanelBtn(btnState) {
        this.closeAllOtherToggles(`${btnState}`)
        this.setState({ [btnState]: !this.state[btnState] })
    }

    toggleDegreesBtn() {
        this.togglePanelBtn("degreesBtnActive")
    }

    toggleNodeTypeBtn() {
        this.togglePanelBtn("nodeTypesBtnActive")
    }

    toggleSliderPanelBtn() {
        this.togglePanelBtn("linkSliderBtnActive")
    }

    toggleTooltips() {
        this.setState({ allowTooltips: !this.state.allowTooltips })
    }

    toggleLabels() {
        this.setState({ showLabels: !this.state.showLabels })
    }

    /*
        Returns a filter group with toggle to increase/decrease the degrees
        separation displayed in the graph
    */
    renderDegreeControls() {
        const id = "degree-controls"
        const increaseDegreesActive = !(this.state.degreesSeparation === MAX_DEGREES_SEPARATION)
        const decreaseDegreesActive = !(this.state.degreesSeparation === MIN_DEGREES_SEPARATION)
        const panelTitle = "Expand Degrees"
        const degreeTooltipText =
            "Expand the network to a higher degrees of separation -- " +
            "i.e. show first friends, and then friends of friends, then friends of friends of friends."

        const degreeContent = (
            <div className="toggle-filter">
                <button
                    className={classNames({
                        "btn btn-default-white": true,
                        disabled: !decreaseDegreesActive ? true : false,
                    })}
                    onClick={this.decreaseDegreesSeparation}
                >
                    <i className={`fa fa-caret-down`} />
                </button>
                <div id="degrees-text">
                    <FormLabel>{`${ordinalSuffix(this.state.degreesSeparation)} Degree `}</FormLabel>
                </div>
                <button
                    className={classNames({
                        "btn btn-default-white": true,
                        disabled: !increaseDegreesActive ? true : false,
                    })}
                    onClick={this.increaseDegreesSeparation}
                >
                    <i className={`fa fa-caret-up`} />
                </button>
            </div>
        )

        return (
            <GraphPanelGroup panelId={id} title={panelTitle} tooltipText={degreeTooltipText} content={degreeContent} />
        )
    }

    /*
        Returns a filter with toggles for each node type in the graph
        i.e. Person, Supporter, Organization, User
     */
    renderNodeTypeFilter() {
        const id = "node-type-panel"
        const title = "Filter by Type"
        const tooltipText = "Filter by the type of the node."
        const isValueActive = (value) => this.state.activeNodeTypes.includes(value)
        const nodeTypeContent = (
            <ul className="list-group " key="node-types-list">
                <a key="node-types-a">
                    {[NodeType.Person, NodeType.Supporter, NodeType.Organization, NodeType.User].map(
                        ({ resource: { value, singular } }, i) => (
                            <li
                                className="list-group-item"
                                key={`node-type-${i}`}
                                onClick={() => this.toggleActiveNodeTypes(value)}
                            >
                                <div className="filter-subgroup-title">
                                    <div className="hoverscroll-container">
                                        <div className="hoverscroll">{singular}</div>
                                    </div>
                                    <i className={`fa fa${isValueActive(value) ? "-check" : ""}-square-o`} />
                                </div>
                            </li>
                        ),
                    )}
                </a>
            </ul>
        )

        return <GraphPanelGroup panelId={id} title={title} tooltipText={tooltipText} content={nodeTypeContent} />
    }

    /*
        Returns a slider that set how many links to show in the graph.
        It is initially set to a number below the the MAX_LINKS
        (which is just a suggestion, user can show more links - the animation will
        just suffer and the user will realize that they can't get as much out of
        the feature with 70,000 links anyway)
     */
    renderNumLinkSlider() {
        const id = "link-slider"
        const title = "Filter Connections"
        const tooltipText = `Filter the graph by strength of relationship.`

        const minLinks = 1

        // did you know that Math.max will cause a recursive error if there are more than
        // ~125k elements in an array?
        const arrayMax = (arr) => arr.reduce((acc, x) => (acc > x ? acc : x), 0)
        const maxLinks = arrayMax(this.state.data.links.map((link) => link.frequency))

        const sliderProps = {
            defaultValue: minLinks,
            value: this.state.strengthConstraint,
            slideStop: this.setStrengthConstraint,
            min: minLinks,
            max: maxLinks,
        }

        const sliderElement = (
            <div className="toggle-filter" id="num-link-slider">
                <div>
                    <ReactBootstrapSlider {...sliderProps} />
                </div>
                <div className="slider-values">
                    <span>{"Weakest"}</span>
                    <span>{"Strongest"}</span>
                </div>
            </div>
        )

        return <GraphPanelGroup panelId={id} title={title} tooltipText={tooltipText} content={sliderElement} />
    }

    /*
        Returns all the buttons displayed below the filter
            1. Show/Hide Labels
            2. Download Graph
            3. Download CSV -- this is the same as the download spreadsheet for Notes search
    */
    renderButtonControls() {
        const showApply = Boolean(this.state.selectedNodes.length || this.state.selectedLinks.length)
        const hideUnselectedTooltip = `Click to hide or show nodes that are have not been selected.`
        const applyFiltersTooltipText = `Click to filter results below with relationships selected in graph.`
        const clearFiltersTooltipText = `Click to clear selections you made inside this graph. This will clear selections inside the graph, but will not clear all filters in your Notes search.`
        return (
            <div id="button-controls" key="button-controls">
                <hr />
                <button
                    className={classNames("btn btn-primary button-s btn-block", { disabled: !showApply })}
                    onClick={this.toggleOnlyShowSelected}
                    key="toggle-selected"
                >
                    {this.state.onlyShowSelected ? "Show All Nodes" : "Only Show Selected Nodes"}
                    <Tooltip label={hideUnselectedTooltip} placement="top">
                        <i className="fa fa-fw fa-info-circle" id="info-click" />
                    </Tooltip>
                </button>
                <button
                    className={classNames("btn btn-default button-s btn-block", { disabled: !showApply })}
                    onClick={this.clearSelectedNodes}
                    key="clear-selection"
                >
                    {` Clear Selected Nodes `}
                    <Tooltip label="Clear the selected nodes." placement="top">
                        <i className="fa fa-fw fa-info-circle" id="info-click" />
                    </Tooltip>
                </button>
                <hr />
                {!this.props.isStats && (
                    <div>
                        <button
                            className={classNames("btn btn-primary button-s btn-block", { disabled: !showApply })}
                            onClick={this.publishFilters}
                            key="apply-filters"
                        >
                            {` Apply Filters to Search `}
                            <Tooltip label={applyFiltersTooltipText} placement="top">
                                <i className="fa fa-fw fa-info-circle" id="info-click" />
                            </Tooltip>
                        </button>
                        <button
                            className={classNames("btn btn-default button-s btn-block", { disabled: !showApply })}
                            onClick={this.clearFilterSelections}
                            key="clear-filters"
                        >
                            {` Clear Search Filters `}
                            <Tooltip label={clearFiltersTooltipText} placement="top">
                                <i className="fa fa-fw fa-info-circle" id="info-click" />
                            </Tooltip>
                        </button>
                        <hr />
                    </div>
                )}
                <button
                    className={classNames({
                        "btn btn-default-white button-s btn-block": true,
                        "hide-labels": this.state.showLabels ? true : false,
                    })}
                    onClick={this.toggleLabels}
                    key="toggle-labels"
                >
                    {this.state.showLabels ? "Hide Labels" : "Show Labels"}
                </button>
                <button
                    className="btn btn-default-white button-s btn-block"
                    onClick={this.downloadImage}
                    key="download-graph"
                >
                    <i className="fa fa-area-chart button-i" />
                    {` Download Graph`}
                </button>
                <button
                    className="btn btn-default-white button-s btn-block"
                    onClick={this.downloadCSV}
                    key="download-spreadsheet"
                >
                    <i className="fa fa-table button-i" />
                    {` Download Spreadsheet`}
                </button>
            </div>
        )
    }

    downloadImage() {
        sendUserActionPost({
            userActionType: DjangIO.app.useractions.types.UserActionType.graph_download,
            description: "Network",
        })
        return window.graphSVGDownload(`${GRAPH_WRAPPER_ID}`)
    }

    downloadCSV() {
        swal("Nice!", "Your download has begun.", "success")
        sendUserActionPost({
            userActionType: DjangIO.app.useractions.types.UserActionType.spreadsheet_download,
            description: "Network",
        })

        // grab the data in the graph
        const constrainedData = this.filterDataByStrength(this.state.data.links)

        const graphData = this.state.onlyShowSelected ? this.filterDataBySelection(constrainedData) : constrainedData

        // take that data, and turn the links into a csv (properly escaping / wrapping fields in quotes)
        let output = []
        graphData.links.forEach((link) => {
            output.push(
                [
                    `"${this.state.nodeMap[link.source].name}"`,
                    `"${this.state.nodeMap[link.target].name}"`,
                    link.frequency,
                ].join(","),
            )
        })

        // now join that information together and add the data: link
        const csvContent = encodeURI(
            `data:text/csv;charset=utf-8,Source,Target,${
                this.props.data &&
                this.props.data.edges &&
                this.props.data.edges.length &&
                this.props.data.edges[0].frequencyField
                    ? this.props.data.edges[0].frequencyField
                    : "Number of Shared Notes"
            }\n${output.join("\n")}`,
        )

        // create a hidden link and go click on it -- this will start the download
        const link = document.createElement("a")
        link.setAttribute("href", csvContent)
        link.setAttribute("download", "Network Data - Generated by Quorum.csv")
        document.body.appendChild(link)

        link.click()
    }

    /*
        Renders all applicable controls
        - Degrees filter only applicable when this.props.currentFilters includes a filter on participants
     */
    renderControls() {
        // bundle up all the filters dealing with participants
        const aggregatedFilters = Object.values(NodeType)
            .map(({ filterKey }) => filterKey)
            .reduce((filters, filterKey) => {
                if (this.props.currentFilters.get(filterKey)) {
                    return filters.concat(this.props.currentFilters.get(filterKey))
                }
                if (this.props.permanentFilter && this.props.permanentFilter[filterKey]) {
                    return filters.concat(this.props.permanentFilter[filterKey])
                }
                // special case for member profiles where the member_or_office method is used
                if (this.props.permanentFilter && this.props.permanentFilter["involving_member_or_office"]) {
                    return filters.concat(this.props.permanentFilter["involving_member_or_office"])
                }
                return filters
            }, [])
        // if this list is not empty, then there are filters set and
        // we want to show the Degrees filter
        const showDegrees = Boolean(aggregatedFilters.length)
        return (
            <div className="network-graph-controls">
                {showDegrees && this.renderDegreeControls()}
                {!this.props.isStats && this.renderNodeTypeFilter()}
                {this.renderNumLinkSlider()}
                {this.renderButtonControls()}
            </div>
        )
    }

    render() {
        const id = "notes-adv-src-network-graph"
        // filter data based on number of links set in 'Relationship Strength' panel
        const constrainedData = this.filterDataByStrength(this.state.data.links)

        const graphData = this.state.onlyShowSelected ? this.filterDataBySelection(constrainedData) : constrainedData
        const partyArray = DjangIO.app.person.types.Party.items()
        const getNodeColor = (nodeId) => {
            const partyObj = partyArray.find((party) => party.label === this.state.nodeMap[nodeId].node_type)
            if (partyObj) {
                return partyObj.color
            }
            return constants.PARTY_COLORS.OTHER
        }
        const graphProps = {
            id,
            wrapperId: GRAPH_WRAPPER_ID,
            data: graphData,
            nodeMap: this.state.nodeMap,
            selectedNodes: this.state.selectedNodes,
            selectedLinks: this.state.selectedLinks,
            onNodeClick: this.selectNodeInGraph,
            onLinkClick: this.selectLinkInGraph,
            showLabels: this.state.showLabels,
            getNodeLabel: (nodeId) => this.state.nodeMap[nodeId].name,
            nodeColors: (nodeId) => getNodeColor(nodeId),
            ...AdvancedSearchNetworkGraph.defaultProps.graphProps,
        }

        // add whatever graphProps were passed to the graphProps
        Object.assign(graphProps, this.props.graphProps)

        if (this.state.allowTooltips) {
            // the getNodeTooltipContent in props is handled in this components this.getNodeTooltipContent,
            // so make sure to hand that to NetworkGraph
            graphProps.getNodeTooltipContent = this.getNodeTooltipContent
            graphProps.getLinkTooltipContent = this.getLinkTooltipContent
        }

        return (
            <div id="advanced-search-network" className="row advanced-search-visualization">
                <div className="col-md-12">
                    {this.state.loading && <LoadingSpinner id="advanced-search-network-loading" />}
                    <Col md={this.props.hideControls ? 12 : 9} id={GRAPH_WRAPPER_ID} key="graph">
                        {graphData.nodes.length ? (
                            <NetworkGraph {...graphProps} />
                        ) : (
                            // NOTE: what to display when user has unselected all node types
                            // or gotten to no data some other way
                            <div className="no-results">No results for this combination of filters.</div>
                        )}
                    </Col>
                    {!this.props.hideControls && (
                        <Col md={3} id="controls" key="controls">
                            {this.renderControls()}
                        </Col>
                    )}
                </div>
            </div>
        )
    }
}

AdvancedSearchNetworkGraph.propTypes = {
    currentFilters: PropTypes.object.isRequired,
    resource: PropTypes.object.isRequired,
    publishFilterChanges: PropTypes.func.isRequired,
    isStats: PropTypes.bool,
    /**
     * Member Profile Relationship Network
     * Data format (of this.props.data):
     *      edges: [
     *          { target: <id>, source: <id>, frequency: <num>, frequencyField: 'Hoyer Score', label: <string>},
     *      ],
     *      nodes: {
     *          <id>: { node_type, name },
     *          <id>: { node_type, name },
     *          ...
     *      }
     * Fields to decide graph scales:
     *     Use frequency for node size, line weight, and line strength
     *     Use node_type for node color
     *
     * Issue Profile Relationship Network:
     * Data format (of this.props.data):
     *     edges: [
     *         { source: <id>, target: <id>, frequency: <num>}
     *     ],
     *     nodes: {
     *         <id>: { node_type, name }
     *     }
     * Fields to decide graph scales:
     *     Use frequency for node size, line weight, and line strength
     *     Use node_type for node color
     *
     * NotesFLV Relationship Network:
     * Data format (of this.props.data):
     *     edges: [
     *         { source: <id>, target: <id>, frequency: <num>}
     *     ],
     *     nodes: {
     *         <id>: { database_id, name, node_type, unique_id }
     *     }
     * Fields to decide graph scales:
     *     Use frequency for node size, line weight, and line strength
     *     Use node_type for node color
     */
    data: PropTypes.arrayOf(
        PropTypes.shape({
            frequency: PropTypes.number.isRequired,
            source: PropTypes.string.isRequired,
            target: PropTypes.string.isRequired,
        }),
    ),
    graphProps: PropTypes.shape({
        centerNodeId: PropTypes.string, // if this graph needs to be centered on a specific node (e.g. member profile relationship graph)
    }),
    updateMultipleFilters: PropTypes.func.isRequired,
    getNodeTooltipContent: PropTypes.func, // format is (id, totalFrequency) => html as string, where totalFrequency is the sum of the frequencies of all the links with the nodeId as the source
    cannotSelectNodes: PropTypes.bool,
}

AdvancedSearchNetworkGraph.defaultProps = {
    currentFilters: Immutable.Map(),
    graphProps: {
        sizeKey: "frequency",
        colorKey: "node_type",
        lineWeightKey: "frequency",
        lineStrengthKey: "frequency",
    },
    cannotSelectNodes: false,
}

export default connect(selectNetworkGraphProps, { updateFilter, updateMultipleFilters })(AdvancedSearchNetworkGraph)
